















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {SurveyQuestionType} from '../../../gql-types/globalTypes';
import MultipleAnswerResponse from '@/components/Events/SurveyResponse/MultipleAnswerResponse.vue';
import MultipleChoiceResponse from '@/components/Events/SurveyResponse/MultipleChoiceResponse.vue';
import MultipleChoiceDropdownResponse from '@/components/Events/SurveyResponse/MultipleChoiceDropdownResponse.vue';
import TextResponse from '@/components/Events/SurveyResponse/TextResponse.vue';

@Component
export default class SurveyQuestion extends Vue {
  @Prop(Object) public readonly question!: any;
  @Prop(String) public readonly value!: string;
  @Prop(Number) public readonly index!: number;


  public getResponseComponent(questionType: SurveyQuestionType) {
    switch (questionType) {
      case SurveyQuestionType.MULTIPLE_ANSWER:
        return MultipleAnswerResponse;
      case SurveyQuestionType.MULTIPLE_CHOICE:
        return MultipleChoiceResponse;
      case SurveyQuestionType.MULTIPLE_CHOICE_DROPDOWN:
        return MultipleChoiceDropdownResponse;

      default:
      case SurveyQuestionType.FILL_BLANKS: // reuse TEXT for FILL_BLANKS
      case SurveyQuestionType.TEXT:
        return TextResponse;
    }
  }

  public emitInput(value) {
    // homogenize raw values and InputEvents.
    if (value && value.target !== undefined) {
      value = value.target.value;
    }

    this.$emit('input', JSON.stringify(value));
  }
}
